import { BonusReportForPlaceTranslations } from "./bonus-report-for-place-pt-br";

export const BONUS_REPORT_FOR_PLACE_ES_MX: BonusReportForPlaceTranslations = {
	title: "Bonificación",
};
